module.exports = __webpack_public_path__ + "img/blog-7.acb6749f.webp";